import React, { useState } from "react";
import { ReactComponent as UploadIcon } from "../../../assets/icons/upload.svg";

const CustomInputFile = ({ onFileSelect, chooseFile }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type === "application/pdf") {
        setSelectedFile(file);
        setErrorMessage("");
        if (onFileSelect) onFileSelect(file); // Truyền file thực tế
      } else {
        setErrorMessage("Chỉ được tải lên tệp PDF.");
      }
    }
  };

  const truncateFileName = (fileName, maxLength = 15) => {
    if (fileName.length <= maxLength) return fileName;
    const fileExtension = fileName.slice(fileName.lastIndexOf("."));
    const baseName = fileName.slice(0, maxLength - fileExtension.length - 5); // 5 ký tự cho " ... "
    return `${baseName} ... ${fileExtension}`;
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="border border-blue-400 rounded-lg p-3 flex items-center gap-2 cursor-pointer">
        <UploadIcon className="text-blue-500" />
        <span className="text-blue-500">
          {selectedFile
            ? truncateFileName(selectedFile.name)
            : chooseFile
            ? truncateFileName(chooseFile)
            : "Chọn tệp tài liệu"}
        </span>
        <input
          type="file"
          accept=".pdf"
          onChange={handleFileChange}
          className="hidden"
        />
      </label>
      {errorMessage && <p className="text-red-500 text-sm">{errorMessage}</p>}
    </div>
  );
};

export default CustomInputFile;
